import React, { useCallback } from "react";
import { StaticImage } from "gatsby-plugin-image";

import { Section } from "components/common/Section";
import { Container } from "components/common/Container";
import { Banner } from "components/common/Banner";
import LogoIllustration from "svg/hero-logo.inline.svg";
import GlassIllustration from "svg/glass-hero.inline.svg";

import * as s from "./Hero.module.sass";

type HeroProps = {
  header: string;
  button: {
    desktop: string;
    mobile: string;
  };
};

export const Hero: FC<HeroProps> = ({
  header,
  button: { desktop, mobile },
}) => {
  const scrollBottom = useCallback(() => {
    const section = document.querySelector("#products");
    if (section) {
      section.scrollIntoView({
        behavior: "smooth",
      });
    }
  }, []);

  return (
    <Section className={s.root}>
      <GlassIllustration className={s.illustration} />
      <Container className={s.container}>
        <LogoIllustration className={s.logo} />
        <div className={s.wavesRightTop}>
          <StaticImage
            src="../../../images/hero-waves-right-top.png"
            objectFit="contain"
            loading="eager"
            placeholder="none"
            quality={80}
            alt={header}
          />
        </div>
        <div className={s.wavesRightBottom}>
          <StaticImage
            src="../../../images/hero-waves-right-bottom.png"
            objectFit="contain"
            loading="eager"
            placeholder="none"
            quality={80}
            alt={header}
          />
        </div>
        <div className={s.octobro}>
          <StaticImage
            src="../../../images/hero-octobro.png"
            objectFit="contain"
            loading="eager"
            placeholder="none"
            quality={80}
            alt={header}
          />
        </div>
        <div className={s.wavesLeft}>
          <StaticImage
            src="../../../images/hero-waves-left.png"
            objectFit="contain"
            loading="eager"
            placeholder="none"
            quality={80}
            alt={header}
          />
        </div>
        <Banner
          title={header}
          button={{
            label: (
              <>
                <span className={s.mobile}>{mobile}</span>
                <span className={s.desktop}>{desktop}</span>
              </>
            ),
            onClick: scrollBottom,
          }}
          glassType="hero"
        />
      </Container>
    </Section>
  );
};
